import classNames from 'classnames'

import Modal from 'shared/components/Modal'
import Checkbox from 'shared/components/Checkbox'
import { isMobile } from 'shared/responsive-helpers'
import CircleLoader from 'shared/components/CircleLoader'
import { RateCurrency } from 'shared/price-utilities'

import bookingStyles from '../styles.module.scss'

const AdditionalItemsModal = ({
    additionalParkingItems,
    onCancelClick,
    onConfirmClick,
    onClose,
    selectedAdditionalService,
    setSelectedAdditionalService,
    currency,
}) => (
    <Modal
        header={<T>booking.additional.services.modal.heading</T>}
        size={isMobile() ? 'small' : 'large'}
        noHeaderPaddings
        onClose={onClose}
        className={bookingStyles.additionalItemsModal}
        buttons={[
            {
                label: <T>booking.additional.services.close.button</T>,
                onClick: () => onCancelClick(),
                btnClassName: 'brand-button--outline',
            },
            {
                label: <T>booking.additional.services.add.button</T>,
                onClick: () => onConfirmClick(),
                disabled: selectedAdditionalService.length === 0,
            },
        ]}>
        {additionalParkingItems ? (
            additionalParkingItems.map((option, index) => (
                <div key={index} className={classNames(bookingStyles.additionalItems)}>
                    <div className="d-flex justify-content-between">
                        <div className={classNames(bookingStyles.checkboxWrap)}>
                            <Checkbox
                                className={classNames('ml-0 d-flex align-items-center', bookingStyles.rateName)}
                                checked={selectedAdditionalService.find(item => item.id === option.id)}
                                label={option.feeName}
                                name="offers_checked"
                                onChange={() => setSelectedAdditionalService(option)}
                            />
                            <div className={bookingStyles.shortServiceDescription}>{option.shortDescription}</div>
                        </div>
                        <div>
                            <span className={bookingStyles.rateAmount}>
                                <RateCurrency rate={option} value={option.value} currency={currency} />
                            </span>
                        </div>
                    </div>
                </div>
            ))
        ) : (
            <div className="d-flex justify-content-center p-5 align-items-center">
                <CircleLoader />
            </div>
        )}
    </Modal>
)
export default AdditionalItemsModal
